/**
 * An operation outlived its deadline. The underlying work may still be running (a promise cannot
 * be cancelled from outside), but nothing waits on it any longer: its awaiter has been handed this
 * error instead of an endless spinner.
 *
 * The message contains "timed out" on purpose: `describeFailureForUser` classifies it as a
 * transient failure, so every surface shows its ordinary "try again" affordance for it.
 */
export class DeadlineExceededError extends Error {
  readonly deadlineMs: number;
  readonly operation: string;

  constructor(operation: string, deadlineMs: number) {
    super(`${operation} timed out after ${deadlineMs}ms`);
    this.name = "DeadlineExceededError";
    this.deadlineMs = deadlineMs;
    this.operation = operation;
  }
}

export function isDeadlineExceededError(error: unknown): error is DeadlineExceededError {
  return error instanceof DeadlineExceededError;
}
